import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class WorkService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/works', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/work/{id}', { id: id }), params);
	}
}